// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card{margin-top:5px}.el-card,.el-card div{margin-bottom:5px}@media (max-width:800px){.card-based{display:block}.list-based{display:none}}@media (min-width:800px){.card-based{display:none}.list-based{display:block}}", ""]);
// Exports
module.exports = exports;
